import { useLayoutEffect } from "react";

function upsertHeadElement(selector, tagName, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement(tagName);
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
}

function SeoHead({ title, description, canonical, robots }) {
  useLayoutEffect(() => {
    if (typeof document === "undefined") return;
    if (title) document.title = title;

    if (description) {
      upsertHeadElement('meta[name="description"]', "meta", { name: "description", content: description });
    } else {
      document.head.querySelector('meta[name="description"]')?.remove();
    }

    if (canonical) {
      upsertHeadElement('link[rel="canonical"]', "link", { rel: "canonical", href: canonical });
    } else {
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }

    if (robots) {
      upsertHeadElement('meta[name="robots"]', "meta", { name: "robots", content: robots });
    } else {
      document.head.querySelector('meta[name="robots"]')?.remove();
    }
  }, [canonical, description, robots, title]);
  return null;
}

export default SeoHead;